import React from "react";
import AuthorityPage from "@/components/AuthorityPage";
import { QUALITY_ASSURANCE } from "@/lib/authorityContent";

export default function QualityAssurance() {
  return <AuthorityPage {...QUALITY_ASSURANCE} pageType="WebPage" testid="quality-assurance-page" />;
}
